/**
 * 客户回款，银行登记单 详情页面配置
 * @author zjs
 * @time 2017-10-26
 */
export default {
    data () {
        return {
            infoConfig : [
                {"label":"登记日期","prop":"work_time"},
                {"label":"回款日期","prop":"huikuan_time"},
                {"label":"登记单号","prop":"transaction_no_display"},
                {"label":"收款账户","prop":"shoukuanzh_name"},
                {"label":"收款金额","prop":"shoukuan_amount"},
                {"label":"登记人","prop":"dengjiren"},
                {"label":"摘要","prop":"zhaiyao","colspan":5},
            ], // 详情信息的配置
            customerConfig: {
                config: {
                    isNumber: true
                },
                head: [
                    {
                        "prop": "customer_account",
                        "label": "客户编码"
                    }, {
                        "prop": "customer_name",
                        "label": "客户名称"
                    }, {
                        "prop": "huikuan_amount",
                        "label": "实收/实退金额"
                    }, {
                        "prop": "shouxufei",
                        "label": "手续费"
                    }, {
                        "prop": "weidu_name",
                        "label": "核算纬度"
                    }, {
                        "prop": "employee_name",
                        "label": "单据业务员"
                    }, {
                        "prop": "remark",
                        "label": "备注"
                    }
                ]
            }, // 客户列表的配置
            billConfig: [
                {"label":"流水号","prop":"transaction_no_display"},
                {"label":"交易日期","prop":"trade_time"},
                {"label":"交易行名","prop":"trade_name"},
                {"label":"银行账户名称","prop":"account_name"},
                {"label":"收款金额","prop":"amount"},
                {"label":"交易方式","prop":"trade_way"},
                {"label":"交易渠道","prop":"trade_channel"},
                {"label":"交易说明","prop":"trade_remark"},
                {"label":"对账人","prop":"clerk_name"},
                {"label":"交易往来","prop":"trade_transact","colspan":5},
            ] // 对账信息的配置
        }
    }
}